export default __webpack_public_path__ + "static/media/close.2d648f5d.svg";